export const getUnitOverviewTour = () => [
  {
    target: 'body',
    title: 'Units',
    content:
      'Units giver dig overblik over de fysiske enheder, der er oprettet på kontoen, og hvilke sensorer der er tilkoblet hver unit.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="datagrid-toolbar"]',
    spotlightTarget: '[data-tour="unit-overview-grid"]',
    title: 'Oversigt over dine units',
    content:
      'I unit-tabellen kan du se Unit ID, navn, sensorforbindelser og tags for hver unit.',
    placement: 'auto',
  },
  {
    target: '[data-tour="unit-overview-add"]',
    title: 'Opret ny unit',
    content: 'Brug denne knap til at oprette en ny unit og tilknytte sensorer.',
    placement: 'left',
  },
  {
    target: '[data-tour="datagrid-search-trigger"]',
    title: 'Søg efter units',
    content: 'Brug søgefeltet til hurtigt at finde en bestemt unit.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="datagrid-columns-trigger"]',
    title: 'Vælg kolonner',
    content: 'Du kan tilpasse hvilke kolonner der vises i tabellen.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="datagrid-filters-trigger"]',
    title: 'Filtrer units',
    content: 'Brug filtre til at afgrænse visningen af units.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="datagrid-export-trigger"]',
    title: 'Eksporter unit-data',
    content: 'Du kan eksportere unit-tabellen til Excel eller CSV.',
    placement: 'bottom',
  },
];
